/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.
/*
const awsmobile = {
    "aws_project_region": "us-east-2",
    "aws_cognito_identity_pool_id": "us-east-2:12870748-c65c-4c86-8e6a-bf222e7740c2",
    "aws_cognito_region": "us-east-2",
    "aws_user_pools_id": "us-east-2_4TP7FqphW",
    "aws_user_pools_web_client_id": "6un91hmknjur7jhcuufvjvgf3m",
    "oauth": {},
    "aws_cognito_login_mechanisms": [
        "EMAIL"
    ],
    "aws_cognito_signup_attributes": [
        "EMAIL"
    ],
    "aws_cognito_mfa_configuration": "OFF",
    "aws_cognito_mfa_types": [
        "SMS"
    ],
    "aws_cognito_password_protection_settings": {
        "passwordPolicyMinLength": 8,
        "passwordPolicyCharacters": []
    }
};
*/
const awsmobile = {
    "aws_project_region": "us-east-2",
    "aws_cognito_identity_pool_id": "us-east-1:53dab47f-3ac3-4b82-b2eb-42bd9ff4f3c0",
    "aws_cognito_region": "us-east-1",
    "aws_user_pools_id": "us-east-1_XGTqoH5ys",
    "aws_user_pools_web_client_id": "3sf45uod0gkjhfe4gp3n93hnb0",
    "oauth": {},
    "aws_cognito_login_mechanisms": [
        "EMAIL"
    ],
    "aws_cognito_signup_attributes": [
        "EMAIL"
    ],
    "aws_cognito_mfa_configuration": "OFF",
    "aws_cognito_mfa_types": [
        "SMS"
    ],
    "aws_cognito_password_protection_settings": {
        "passwordPolicyMinLength": 8,
        "passwordPolicyCharacters": []
    }
};
export default awsmobile;
